// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
    factory('ssoOrganizations', ['$http', '$q', 'obexConstant', 'authService',
      ($http, $q, obexConstant, authService) => {
        return {
          getSsoOrganizationById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlSsoOrganization}/id/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          getSsoOrganizationsByOrgId(organizationId) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlSsoOrganization}/organizationid/${organizationId}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          //curd operation
          addSsoOrganization(ssoOrganization, orgId) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const postData = {
                Id: 0,
                OrganizationCode: ssoOrganization.organizationCode,
                GlobalId: ssoOrganization.globalId,
                OrganizationId: orgId,
              };
              return $http.post(obexConstant.urlSsoOrganization, postData, {
                headers: authHeader,
              });
            });
          },
          updateSsoOrganization(id, ssoOrganization) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlSsoOrganization}/id/${id}`;
              const putData = {
                Id: ssoOrganization.id,
                OrganizationCode: ssoOrganization.organizationCode,
                GlobalId: ssoOrganization.globalId,
                OrganizationId: ssoOrganization.organizationId,
              };
              return $http.put(url, putData, {
                headers: authHeader,
              });
            });
          },
        };
      },
    ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/ssoOrganizations.service.js